import { purgeAnonymousTelemetry } from './api';
import { clearTelemetryVisitorId, getStoredTelemetryVisitorId } from './visitor';

/** Deletes server-side anonymous rows for this browser and clears the local visitor id. */
export async function purgeAnonymousTelemetryIfStored(): Promise<void> {
  const id = getStoredTelemetryVisitorId();
  if (!id) return;
  try {
    await purgeAnonymousTelemetry(id);
    clearTelemetryVisitorId();
  } catch {
    // Keep visitor id so a later session can retry; tracker does not send while logged in.
  }
}
